import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import injectSheet from "react-jss";
import { ListType, ViewType } from "./utils/Enums";
import ProtectedRoute from "./utils/hocs/ProtectedRoute";
import AbsoluteLoaderContainer from "./components/Loaders/AbsoluteLoaderContainer";

const Start = lazy(() => import("./pages/home/Start"));
const ListContainer = lazy(() =>
  import("./layouts/ListContainer/ListContainer")
);
const MinSida = lazy(() => import("./pages/profile/MinSida"));
const AccountManagement = lazy(() =>
  import("./pages/account/AccountManagement")
);
const Synpunkt = lazy(() => import("./pages/feedback/Synpunkt"));
const Arrangemang = lazy(() => import("./pages/arrangemang/Arrangemang"));
const StartSamverkanspart = lazy(() =>
  import("./pages/samverkanspart/home/StartSamverkanspart")
);
const Logout = lazy(() => import("./pages/authentication/Logout"));
const ArrangemangSignera = lazy(() =>
  import("./pages/narvaro/ArrangemangSignera")
);
const ArrangemangActionDone = lazy(() =>
  import("./components/arrangemang-components/ArrangemangActionDone")
);
const ArrangemangRegistrera = lazy(() =>
  import("./pages/narvaro/ArrangemangRegistrera")
);
const ArrangemangEnkelNarvaro = lazy(() =>
  import("./pages/narvaro/EnkelNarvaro/ArrangemangEnkelNarvaro")
);
const ArrangemangVisa = lazy(() => import("./pages/narvaro/ArrangemangVisa"));
const ArrangemangKontrollera = lazy(() =>
  import("./components/KontrolleraSlutrapportera/ArrangemangKontrollera")
);
const Document = lazy(() => import("./pages/samverkanspart/document/Document"));
const Logg = lazy(() => import("./pages/samverkanspart/logg/Logg"));
const Event = lazy(() => import("./pages/samverkanspart/event/Event"));
const Booking = lazy(() => import("./pages/Booking/Booking"));
const Settings = lazy(() => import("./pages/samverkanspart/settings/Settings"));

function MainContainer(props) {
  const { classes, userState } = props;

  const topMenu = userState.samverkansparts?.find(
    (element) => element.administrator
  );

  return (
    <div className={classes.container}>
      <div className={topMenu ? classes.topMenu : classes.content}>
        <Suspense
          fallback={<AbsoluteLoaderContainer totalCenter title="Laddar..." />}
        >
          <Route
            exact
            path={"/"}
            render={() => <Start toggleSubmenu={props.toggleSubmenu} />}
          />
          <Switch>
            <ProtectedRoute
              exact
              path={"/samverkansparts"}
              component={StartSamverkanspart}
            ></ProtectedRoute>
            <ProtectedRoute
              path={"/samverkansparts/document"}
              component={Document}
            />
            <ProtectedRoute path={"/samverkansparts/event"} component={Event} />
            <ProtectedRoute path={"/samverkansparts/logg"} component={Logg} />
            <ProtectedRoute path={"/booking/booking"} component={Booking} />
            <ProtectedRoute
              path={"/samverkansparts/settings"}
              component={Settings}
            />
          </Switch>
          <Route exact path={"/booking"} component={Booking} />
          <Route path={"/logout"} render={(props) => <Logout {...props} />} />
          <Route exact path={"/synpunkt"} component={Synpunkt} />
          <Route exact path={"/min-sida"} component={MinSida} />
          <Route exact path={"/kontohantering"} component={AccountManagement} />
          <Route exact path={"/skapa/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/skapa/:id/skickat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/skapa/:id/kopierat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/godkanda"}
            render={() => (
              <ListContainer
                view={ViewType.VisaGodkända}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/godkanda"}
            render={() => (
              <ListContainer
                view={ViewType.VisaGodkända}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/godkanda"}
            render={() => (
              <ListContainer
                view={ViewType.VisaGodkända}
                listtype={ListType.Avdelning}
              />
            )}
          />

          <Route
            exact
            path={"/samverkansparts/godkanda/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/avdelnings/godkanda/:id"}
            component={Arrangemang}
          />
          <Route exact path={"/godkanda/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/pagaende"}
            render={() => (
              <ListContainer
                view={ViewType.VisaPågående}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/editpagaende"}
            render={() => (
              <ListContainer
                view={ViewType.RedigeraStartade}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/pagaende"}
            render={() => (
              <ListContainer
                view={ViewType.VisaPågående}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/pagaende"}
            render={() => (
              <ListContainer
                view={ViewType.VisaPågående}
                listtype={ListType.Avdelning}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/editpagaende"}
            render={() => (
              <ListContainer
                view={ViewType.RedigeraStartade}
                listtype={ListType.Avdelning}
              />
            )}
          />
          <Route
            exact
            path={"/pagaende/:id"}
            render={() => <ArrangemangVisa listtype={ListType.User} />}
          />
          <Route
            exact
            path={"/editpagaende/:id"}
            render={() => <ArrangemangVisa listtype={ListType.User} />}
          />
          <Route
            exact
            path={"/samverkansparts/pagaende/:id"}
            render={() => (
              <ArrangemangVisa listtype={ListType.Samverkanspart} />
            )}
          />
          <Route
            exact
            path={"/avdelnings/pagaende/:id"}
            render={() => <ArrangemangVisa listtype={ListType.Avdelning} />}
          />
          <Route
            exact
            path={"/avdelnings/editpagaende/:id"}
            render={() => <ArrangemangVisa listtype={ListType.Avdelning} />}
          />
          <Route
            exact
            path={"/slutforda"}
            render={() => (
              <ListContainer
                view={ViewType.VisaSlutförda}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/slutforda"}
            render={() => (
              <ListContainer
                view={ViewType.VisaSlutförda}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/slutforda"}
            render={() => (
              <ListContainer
                view={ViewType.VisaSlutförda}
                listtype={ListType.Avdelning}
              />
            )}
          />
          <Route exact path={"/slutforda/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/samverkansparts/slutforda/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/avdelnings/slutforda/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/arkiverade"}
            render={() => (
              <ListContainer
                view={ViewType.VisaArkiverade}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/arkiverade"}
            render={() => (
              <ListContainer
                view={ViewType.VisaArkiverade}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/arkiverade"}
            render={() => (
              <ListContainer
                view={ViewType.VisaArkiverade}
                listtype={ListType.Avdelning}
              />
            )}
          />
          <Route exact path={"/arkiverade/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/samverkansparts/arkiverade/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/avdelnings/arkiverade/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/ej-godkanda"}
            render={() => (
              <ListContainer
                view={ViewType.InskickadeSomSkaGodkännas}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/ej-godkanda"}
            render={() => (
              <ListContainer
                view={ViewType.InskickadeSomSkaGodkännas}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route exact path={"/ej-godkanda/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/samverkansparts/ej-godkanda/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/ej-tilldelade"}
            render={() => (
              <ListContainer
                view={ViewType.AttSkickaTillStartare}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/ej-tilldelade"}
            render={() => (
              <ListContainer
                view={ViewType.AttSkickaTillStartare}
                listtype={ListType.Avdelning}
              />
            )}
          />

          <Route exact path={"/ej-tilldelade/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/avdelnings/ej-tilldelade/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/ej-tilldelade/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/avdelnings/ej-tilldelade/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />

          <Route
            exact
            path={"/nekade"}
            render={() => (
              <ListContainer
                view={ViewType.NekadeSomSkaKompletteras}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/nekade"}
            render={() => (
              <ListContainer
                view={ViewType.NekadeSomSkaKompletteras}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route exact path={"/nekade/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/samverkansparts/nekade/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/nekade/:id/skickat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/samverkansparts/nekade/:id/skickat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/godkanna"}
            render={() => (
              <ListContainer
                view={ViewType.AttGodkänna}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/godkanna"}
            render={() => (
              <ListContainer
                view={ViewType.AttGodkänna}
                listtype={ListType.Avdelning}
              />
            )}
          />
          <Route exact path={"/godkanna/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/avdelnings/godkanna/:id"}
            component={Arrangemang}
          />

          <Route
            exact
            path={"/godkanna/:id/godkant"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/godkanna/:id/ej-godkant"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/starta/:id/ej-godkant"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/samverkansparts/godkanna/:id/godkant"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/avdelnings/godkanna/:id/godkant"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/avdelnings/godkanna/:id/ej-godkant"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/godkanna/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/samverkansparts/godkanna/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/avdelnings/godkanna/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/komplettera-godkanda"}
            render={() => (
              <ListContainer
                view={ViewType.Godkända}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/komplettera-godkanda"}
            render={() => (
              <ListContainer
                view={ViewType.Godkända}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route
            exact
            path={"/komplettera-godkanda/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/samverkansparts/komplettera-godkanda/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/komplettera-godkanda/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/komplettera-ej-behandlade-arrangemang"}
            render={() => (
              <ListContainer
                view={ViewType.EjInskickade}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/komplettera-ej-behandlade-arrangemang"}
            render={() => (
              <ListContainer
                view={ViewType.EjInskickade}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route
            exact
            path={"/komplettera-ej-behandlade-arrangemang/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/samverkansparts/komplettera-ej-behandlade-arrangemang/:id"}
            component={Arrangemang}
          />

          <Route
            exact
            path={"/komplettera-ej-behandlade-arrangemang/:id/skickat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={
              "/samverkansparts/komplettera-ej-behandlade-arrangemang/:id/skickat"
            }
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/slutrapportera"}
            render={() => (
              <ListContainer
                view={ViewType.AttSlutrapportera}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/slutrapportera"}
            render={() => (
              <ListContainer
                view={ViewType.AttSlutrapportera}
                listtype={ListType.Avdelning}
              />
            )}
          />
          <Route
            exact
            path={"/slutrapportera/:id"}
            render={() => <ArrangemangKontrollera listtype={ListType.User} />}
          />
          <Route
            exact
            path={"/avdelnings/slutrapportera/:id"}
            render={() => (
              <ArrangemangKontrollera listtype={ListType.Avdelning} />
            )}
          />
          <Route
            exact
            path={"/slutrapportera/:id/slutrapporterat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/avdelnings/slutrapportera/:id/slutrapporterat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/kontrollera"}
            render={() => (
              <ListContainer
                view={ViewType.AttKontrollera}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/kontrollera"}
            render={() => (
              <ListContainer
                view={ViewType.AttKontrollera}
                listtype={ListType.Avdelning}
              />
            )}
          />
          <Route
            exact
            path={"/kontrollera/:id"}
            render={() => (
              <ArrangemangKontrollera
                listtype={ListType.User}
                view={ViewType.AttKontrollera}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/kontrollera/:id"}
            render={() => (
              <ArrangemangKontrollera
                listtype={ListType.Avdelning}
                view={ViewType.AttKontrollera}
              />
            )}
          />
          <Route
            exact
            path={"/kontrollera/:id/kontrollerat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/avdelnings/kontrollera/:id/kontrollerat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/starta"}
            render={() => (
              <ListContainer
                view={ViewType.AttStarta}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/samverkansparts/starta"}
            render={() => (
              <ListContainer
                view={ViewType.AttStarta}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
          <Route
            exact
            path={"/avdelnings/starta"}
            render={() => (
              <ListContainer
                view={ViewType.AttStarta}
                listtype={ListType.Avdelning}
              />
            )}
          />
          <Route exact path={"/starta/:id"} component={Arrangemang} />
          <Route
            exact
            path={"/avdelnings/starta/:id"}
            component={Arrangemang}
          />
          <Route
            exact
            path={"/skapa/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/starta/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/avdelnings/starta/:id/vidarebefodrat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/starta/:id/startat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/skapa/:id/startat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/samverkansparts/starta/:id/startat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/avdelnings/starta/:id/startat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/registrera-narvaro-signera"}
            render={() => (
              <ListContainer
                view={ViewType.AttRegistreraNärvaro}
                listtype={ListType.User}
              />
            )}
          />
          <Route
            exact
            path={"/registrera-narvaro-signera/:id"}
            component={ArrangemangRegistrera}
          />
          <Route
            exact
            path={"/registrera-narvaro-signera/:id/narvaro"}
            component={ArrangemangEnkelNarvaro}
          />
          <Route
            exact
            path={"/registrera-narvaro-signera/:id/signera"}
            component={ArrangemangSignera}
          />
          <Route
            exact
            path={"/registrera-narvaro-signera/:id/signerat"}
            component={ArrangemangActionDone}
          />
          <Route
            exact
            path={"/search/arrangemang"}
            render={() => (
              <ListContainer
                view={ViewType.AttKontrollera}
                listtype={ListType.Samverkanspart}
              />
            )}
          />
        </Suspense>
      </div>
    </div>
  );
}

const styles = {
  container: {
    marginLeft: "64px",
    marginTop: "56px",
  },
  content: {
    width: "1088px",
    margin: "80px auto",
  },
  topMenu: {
    width: "1088px",
    margin: "110px auto",
  },
  "@media (max-width: 1168px)": {
    content: {
      margin: "80px 16px 29px 16px",
      width: "auto",
    },
  },
  "@media (max-width: 1023px)": {
    container: {
      marginLeft: "0",
      marginTop: "56px",
    },
    content: {
      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
      margin: "0",
    },
    topMenu: {
      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
      margin: "0",
    },
  },
};

const mapStateToProps = (state) => {
  return {
    userState: state.user,
  };
};

const ConnectedMainContainer = connect(mapStateToProps)(MainContainer);

export default injectSheet(styles)(ConnectedMainContainer);

//export default injectSheet(styles)(MainContainer);
